import { STORAGE_KEYS } from './constants/storage.constants';

/**
 * Typed readers for the session data persisted at login. Use these instead of
 * `JSON.parse(localStorage.getItem('...'))` so the storage key and parsing live
 * in one place. Each call parses a fresh copy, so callers may mutate the result.
 */
const read = (key: string): any => JSON.parse(localStorage.getItem(key) || "[]");

/** The logged-in business profile (first entry of the stored profile list). */
export const getUserProfile = (): any => read(STORAGE_KEYS.USER_PROFILE_DATA)[0];

/** The stored profile list as returned by the API. */
export const getUserProfiles = (): any => read(STORAGE_KEYS.USER_PROFILE_DATA);

export const getDoctorSettings = (): any => read(STORAGE_KEYS.DOCTOR_SETTINGS);

export const getStoredLocations = (): any => read(STORAGE_KEYS.LOCATIONS);

export const getStoredRoleId = (): any => read(STORAGE_KEYS.ROLE_ID);

/**
 * Writers for the same keys. They only persist: subscribers of the matching
 * AuthService streams are notified separately by the caller (as before), so
 * switching from a raw `localStorage.setItem` does not change who gets updates.
 */
const write = (key: string, value: any): void => localStorage.setItem(key, JSON.stringify(value));

export const setUserProfiles = (value: any): void => write(STORAGE_KEYS.USER_PROFILE_DATA, value);

export const setDoctorSettings = (value: any): void => write(STORAGE_KEYS.DOCTOR_SETTINGS, value);

export const setStoredLocations = (value: any): void => write(STORAGE_KEYS.LOCATIONS, value);

export const setStoredRoleId = (value: any): void => write(STORAGE_KEYS.ROLE_ID, value);
